<template>
  <div class="panel" v-loading="loading">
    <a class="back" @click="backPage">
      <i class="iconfont icon-icon_return" />返回
    </a>
    <div class="edit-panel">
      <div class="title">
        <span v-if="state === 'created'">{{ "创建方案" }}</span>
        <span v-if="state === 'edit'">{{ "编辑方案" }}</span>
        <span v-if="state === 'preview'">{{ "查看方案" }}</span>
        <el-popover
          v-if="state !== 'preview'"
          placement="bottom-start"
          :width="360"
          trigger="click"
        >
          <template #reference>
            <el-button type="text">草稿箱</el-button>
          </template>
          <div class="draft-box" v-if="templateData.draftBox">
            <div
              class="draft-box__cell"
              v-for="item in templateData.draftBox"
              @click="editDraf(item.uid)"
              :key="item.uid"
            >
              <span>{{ item.name }}</span>
              <i
                @click.stop="deleteDraf(item)"
                class="iconfont icon-icon_trash"
              />
            </div>
          </div>
        </el-popover>
      </div>
      <el-form ref="form" :model="formData" label-width="80px">
        <el-form-item label="方案名称:">
          <span v-if="state === 'preview'">{{ formData.name }}</span>
          <el-input
            v-else
            style="width: 280px"
            v-model="formData.name"
            :readonly="state === 'preview'"
            maxlength="20"
            placeholder="请输入方案名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="投放时间:">
          <p v-if="state === 'preview'">
            <span>{{
              formData.time[0]
                ? formData.time[0].format("YYYY/MM/DD HH:mm:ss")
                : ""
            }}</span>
            <span style="padding: 0 15px">-</span>
            <span>{{
              formData.time[1]
                ? formData.time[1].format("YYYY/MM/DD HH:mm:ss")
                : ""
            }}</span>
          </p>
          <el-date-picker
            v-else
            v-model="formData.time"
            type="datetimerange"
            :readonly="state === 'preview'"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="目标人群:" class="targetPopulation">
          <span v-if="state === 'preview'">{{
            targetPopulationList[formData.targetPopulation]
          }}</span>
          <el-radio-group v-else v-model="formData.targetPopulation">
            <el-radio-button :label="3">
              <div>
                <i class="iconfont icon-icon_screening" />
                按人群筛选
              </div>
            </el-radio-button>
            <el-radio-button :label="0">
              <div>
                <i class="iconfont icon-icon_screening" />
                按条件筛选
              </div>
            </el-radio-button>
            <el-radio-button :label="1">
              <div>
                <i class="iconfont icon-icon_import" />
                导入数据
              </div>
            </el-radio-button>
            <el-radio-button :label="2">
              <div>
                <i class="iconfont icon-icon_lable" />
                不限人群
              </div>
            </el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="formData.targetPopulation == 1" label="导入数据:">
          <div class="excel">
            <el-button
              v-if="state !== 'preview'"
              class="show_list"
              size="small"
              type="primary"
              @click="uploadExcel"
              >上传表格</el-button
            >
            <el-button
              @click.stop="showNameList"
              style="height: 32px"
              size="small"
              class="show_list"
              type="primary"
              >查看名单</el-button
            >
          </div>
        </el-form-item>
        <el-form-item
          v-if="formData.targetPopulation == 0"
          label="选择标签:"
          class="tag_edit"
        >
          <div v-if="state === 'preview'">
            <p>共{{ labelListNames.length }}个</p>
            <span
              v-for="(name, nameIndex) in labelListNames"
              :key="nameIndex"
              class="chooseTagName"
            >
              {{ name }}
            </span>
            <el-button
              v-if="
                formData.targetPopulation == 0 &&
                formData.labelList &&
                formData.labelList.length > 0
              "
              @click="showNameList"
              class="show_list"
              type="primary"
              >查看名单</el-button
            >
          </div>
          <div v-else>
            <el-select
              v-model="formData.labelList"
              :disabled="state === 'preview'"
              multiple
              placeholder="请选择"
              @change="changeHeight"
            >
              <el-option-group
                v-for="group in customerTagGroupDtoList"
                :key="group.customertaggroupUid"
                :label="group.customertaggroupName"
              >
                <el-option
                  v-for="option in group.customerTagDTOList"
                  :key="option.customertagUid"
                  :label="option.customertagName"
                  :value="option.customertagUid"
                >
                </el-option>
              </el-option-group>
            </el-select>
            <el-button
              v-if="
                formData.targetPopulation == 0 &&
                formData.labelList &&
                formData.labelList.length > 0
              "
              @click="showNameList"
              class="show_list"
              type="primary"
              >查看名单</el-button
            >
          </div>
        </el-form-item>
        <el-form-item
          v-if="formData.targetPopulation == 3"
          label="选择人群:"
          class="tag_edit"
        >
          <div v-if="state === 'preview'">
            <p>共{{ customerDataConditionUidListListNames.length }}个</p>
            <span
              v-for="(name, nameIndex) in customerDataConditionUidListListNames"
              :key="nameIndex"
              class="chooseTagName"
            >
              {{ name }}
            </span>
          </div>
          <div v-else>
            <el-select
              v-model="formData.customerDataConditionUidList"
              :disabled="state === 'preview'"
              multiple
              placeholder="请选择"
              @change="changeHeight"
            >
              <el-option
                v-for="option in customerDataConditionSmallDtoList"
                :key="option.customerDataConditionUid"
                :label="option.customerDataConditionName"
                :value="option.customerDataConditionUid"
              >
              </el-option>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item
          v-if="
            formData.targetPopulation == 0 &&
            formData.labelList &&
            formData.labelList.length > 0
          "
          label="标签逻辑:"
        >
          <span v-if="state === 'preview'">{{
            labelLogic === 1 ? "交集" : "并集"
          }}</span>
          <el-radio-group v-else v-model="labelLogic">
            <el-radio :label="1">交集</el-radio>
            <el-radio :label="0">并集</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="投放平台:">
          <div v-if="state === 'preview'">
            {{ chooseList.join(",") }}
          </div>
          <el-checkbox-group v-model="platformList" v-else>
            <el-checkbox-button
              style="margin-bottom: 10px"
              v-for="option in templateData.locationGroupDtoList"
              :label="option.locationGroupUid"
              :key="option.locationGroupUid"
            >
              {{ option.locationGroupName }}
            </el-checkbox-button>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
    </div>
    <PlatformConfiguration
      v-for="item in selectPlatformInfoList"
      @deletePlatform="deletePlatform"
      @deleteProjectByLast="deleteProjectByLast"
      :platformList="platformList"
      :key="item.locationGroupUid"
      :ref="item.locationGroupUid"
      :templateUid="uid"
      :isPreview="state === 'preview'"
      :platformInfo="item"
      @getNeedDeleteTargetLocations="getNeedDeleteTargetLocations"
    />
    <div class="footer" v-if="state === 'created'">
      <div>
        <el-button
          class="footer__button"
          type="primary"
          size="small"
          :disabled="submitAnti"
          @click="submit(0)"
          >发布</el-button
        >
        <el-button
          class="footer__button"
          size="small"
          :disabled="submitAnti"
          @click="submit(1)"
          >存为草稿</el-button
        >
      </div>
      <div class="set_template">
        <el-checkbox class="set_template__checkbox" v-model="saveAsTemplate"
          >将方案保存为模板</el-checkbox
        >
        <el-input
          class="set_template__input"
          v-model="templateName"
          placeholder="请输入模板名称"
        ></el-input>
      </div>
    </div>
    <div class="footer" v-if="state === 'edit'">
      <div>
        <el-button
          type="primary"
          size="small"
          :disabled="submitAnti"
          @click="submit(0)"
          >保存并发布</el-button
        >
        <el-button
          class="footer__button"
          size="small"
          @click="submit(2)"
          :disabled="submitAnti"
          >保存方案</el-button
        >
        <el-button
          class="footer__button"
          size="small"
          type="danger"
          @click="deleteProject()"
          >删除方案</el-button
        >
      </div>
    </div>
    <div class="footer" v-if="state === 'preview'">
      <div>
        <el-button
          class="footer__button"
          size="small"
          type="primary"
          @click="toEdit()"
          >编辑</el-button
        >
        <el-button
          class="footer__button"
          size="small"
          type="danger"
          @click="deleteProject()"
          >删除方案</el-button
        >
      </div>
    </div>
    <div class="show_name">
      <el-dialog v-model="showNameVisible" @close="showNameClose" width="80%">
        <template #title> 筛选结果名单 共{{ nameListInfo.total }}人 </template>
        <div v-loading="showNameLoading">
          <el-table :data="nameListInfo.list">
            <el-table-column label="序号" type="index" align="center">
            </el-table-column>
            <el-table-column label="客户账号" prop="account"> </el-table-column>
            <el-table-column label="客户名称" prop="name"> </el-table-column>
            <el-table-column label="客户电话" prop="tel"> </el-table-column>
            <el-table-column label="客户行业" prop="industry">
            </el-table-column>
          </el-table>
          <el-pagination
            v-if="nameListInfo.total == 0"
            class="pagination"
            :total="0"
            layout="->, prev, pager, next"
          >
          </el-pagination>
          <el-pagination
            v-else
            class="pagination"
            @current-change="changeNameListTabelPage"
            :current-page="nameListInfo.pageNum"
            :page-count="nameListInfo.pages"
            layout="->, prev, pager, next"
          >
          </el-pagination>
        </div>
      </el-dialog>
    </div>
    <el-dialog
      title="提示"
      v-model="checkRepeat"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <p>当前方案存在重合，是否需要覆盖？</p>
      <el-table
        :data="repeatData"
        :header-cell-style="{ background: '#EFF1F4', color: '#000' }"
      >
        <el-table-column
          v-if="formData.targetPopulation === 0"
          property="coveredNames"
          label="覆盖标签"
          width="150"
        >
          <template v-slot="scope">
            <span>{{ scope.row.coveredNames.join("/") }}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-else-if="formData.targetPopulation === 1"
          property="coveredNames"
          label="覆盖人员"
          width="150"
        >
          <template v-slot="scope">
            <span>{{ scope.row.coveredNames.join("/") }}</span>
          </template>
        </el-table-column>
        <el-table-column
          property="projectName"
          label="方案"
          width="200"
        ></el-table-column>
        <el-table-column property="positionNames" label="重合位置">
          <template v-slot="scope">
            <p
              v-for="(positionName, index) in scope.row.positionNames"
              :key="index"
            >
              {{ positionName }}
            </p>
          </template>
        </el-table-column>
        <el-table-column
          property="coveredNames"
          label="方案投放时间"
          width="220"
        >
          <template v-slot="scope">
            <span
              >{{ scope.row.projectStartTime }}至{{
                scope.row.projectEndTime
              }}</span
            >
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <span class="dialog-footer">
          <el-button @click="getCheckResult(0)">取 消</el-button>
          <el-button type="primary" @click="getCheckResult(1)">确 定</el-button>
        </span>
      </template>
    </el-dialog>
    <input type="file" style="display: none" id="excelUpload" />
  </div>
</template>

<script>
import PlatformConfiguration from './components/PlatformConfiguration.vue'
import _ from 'lodash'
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import { updateWhetherOrNotProject } from '../../API/dropData'
import { getDetailTemplate, saveTemplate, deleteTemplate, uploadExcel, getCoveredCustomerDto, deleteTargetLocationMappingByTemplateUidAndLocationGroupUid, deleteTargetLocationMapping } from '../../API/template'
import { getCustomerTagMapping, getCustomerInfoByLeadingIn } from '../../API/tag'
import locationGroupList from '../../utils/locationGroupList'
dayjs.extend(customParseFormat)
export default {
  components: {
    PlatformConfiguration
  },
  data () {
    const id = this.$route && (this.$route.params.id === 'null') ? null : this.$route.params.id
    const state = this.$route.params.state
    return {
      id,
      state,
      targetPopulationList: ['按条件筛选', '导入数据', '不限人群', '按人群筛选'],
      uid: '',
      saveTemplateId: '',
      customerDataConditionUidListListNames: [],
      customerDataConditionSmallDtoList: [],
      formData: {
        name: '',
        time: '',
        targetPopulation: 0,
        fileList: [],
        labelList: []
      },
      labelListNames: [],
      submitAnti: false,
      isflag: false,
      needDeleteLocationGroupUids: [],
      loading: true,
      excelFile: [],
      chooseList: [],
      platformList: [],
      saveAsTemplate: false,
      templateName: '',
      labelLogic: 0,
      userAccount: '',
      isNew: false,
      needDeleteTargetLocations: [],
      nameListInfo: {
        pageNum: 0,
        pageSize: 10,
        pages: 1,
        nextPage: 1,
        list: []
      },
      showNameVisible: false,
      showNameLoading: true,
      templateData: {},
      checkRepeat: false,
      repeatData: [
        {
          tag: '厦门电商', fangan: '大放送活动', position: '云平台y1广告位', time: '2020-7-31 00:00:00 至 2020-7-31 00:00:00'
        }
      ],
      formCheckData: {}
    }
  },
  async mounted () {
    console.log('this.$route', this.$route)
    this.loadDetailTemplate(this.id)
    const self = this
    console.log('2222222222222222222')
    const fileElem = document.getElementById('excelUpload')
    fileElem.addEventListener('change', function () {
      const formData = new FormData()
      console.log('fileElem.files', fileElem.files)
      formData.append('multipartFile', fileElem.files[0])
      uploadExcel(formData).then((data) => {
        if (data && data.leadingInTemporaryTableUid) {
          self.userAccount = data.leadingInTemporaryTableUid
          self.excelFile = [fileElem.files[0]]
        }
        if (data && data.leadingInTemporaryTableUid) {
          self.$notify.success({
            message: '表格上传完成!'
          })
          self.isNew = true
        } else {
          self.$notify.error({
            message: '表格上传失败请重新上传!'
          })
        }
        fileElem.vaule = ''
      })
    })

    // const data = {
    //   customerTagGroupVoList: '[{"customertaggroupUid": 1556009716770106270,"customerTagVoList":[{"customertagUid": 1556009729109534005}]}]',
    //   endTime: '2021/6/23 11:22:00',
    //   locationGroupVoList: '[{"locationVoList":[{"locationUid":1001,"imgUrl":3333,"weight":33}],"locationGroupUid":1000}]',
    //   name: '11111',
    //   startTime: '2021/6/21 11:22:00',
    //   targetPopulation: '0',
    //   type: '0',
    //   labelLogic: '0'
    // }
    // const formData = new FormData()
    // _.map(data, (value, key) => {
    //   formData.append(key, value)
    // })
    // const result = await getCoveredCustomerDto(formData)
    // console.log('result', result)
  },
  computed: {
    customerTagGroupDtoList: function () {
      const data = []
      if (this.templateData.customerTagGroupDtoList && this.templateData.customerTagGroupDtoList.length > 0) {
        this.templateData.customerTagGroupDtoList.forEach(item => {
          if (item.customerTagDTOList.length > 0) {
            data.push(item)
          }
        })
        return data
      } else {
        return []
      }
    },
    selectPlatformInfoList: function () {
      return _.intersectionWith(this.templateData.locationGroupDtoList, this.platformList, (a, b) => {
        if (a.id === b) {
          a.choosed = true
        } else {
          a.choosed = false
        }
        return a.locationGroupUid === b
      })
    }
  },
  methods: {
    showNameClose () {
      this.showNameLoading = true
    },
    changeHeight () {
      this.$nextTick(() => {
        document.querySelector('.select-trigger').style.height = document.querySelector('.el-select__tags>span').clientHeight > 28 ? document.querySelector('.el-select__tags>span').clientHeight + 4 + 'px' : '32px'
      })
    },
    getNeedDeleteTargetLocations (needDeleteTargetLocations) {
      this.needDeleteTargetLocations = needDeleteTargetLocations
    },
    toEdit () {
      console.log('this', this)
      if (this.templateData.whetherOrNot === 0) {
        this.$router.push({
          path: `/create-project/edit/${this.uid}`,
          query: {
            t: Date.now()
          }
        })
      } else {
        this.$confirm('暂停后,当前方案的广告位会被暂停投放', '正在投放的广告无法编辑，请先暂停投放', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          const res = await updateWhetherOrNotProject({ templateUid: this.uid, whetherOrNot: 0 })
          console.log('res', res)
          if (res === '操作成功') {
            this.$message({
              type: 'success',
              message: '方案已暂停'
            })
            this.$router.push({
              path: `/create-project/edit/${this.uid}`,
              query: {
                t: Date.now()
              }
            })
          }
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
      }
    },
    async deleteProjectByLast () {
      if (this.state === 'created') {
        this.$router.push('/create-project')
      } else {
        const res = await updateWhetherOrNotProject({ templateUid: this.uid, whetherOrNot: 0 })
        if (res !== '操作成功') {
          this.$message({
            type: 'error',
            message: res
          })
        } else {
          await deleteTemplate({ templateUid: this.uid })
          this.$router.push('/drop-data')
        }
      }
    },
    deleteProject () {
      const index = this.$router.getRoutes().findIndex(item => item.name !== 'project-edit')
      console.log('index', index)

      this.$confirm('删除后无法复原', '确认删除当前方案', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await updateWhetherOrNotProject({ templateUid: this.uid, whetherOrNot: 0 })
        if (res !== '操作成功') {
          this.$message({
            type: 'error',
            message: res
          })
        } else {
          await deleteTemplate({ templateUid: this.uid })
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          if (index !== -1) {
            this.$router.go(-(index + 1))
          } else {
            this.$router.push('/create-project')
          }
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    async loadDetailTemplate (id) {
      this.loading = true
      const data = await getDetailTemplate({ templateUid: id })
      this.templateData = data
      this.labelLogic = this.templateData.labelLogic || 0
      if (data.name) {
        this.formData.name = data.name
      }
      if (data.startTime && data.endTime) {
        this.formData.time = [dayjs(data.startTime, 'YYYY/MM/DD HH:mm:ss'), dayjs(data.endTime, 'YYYY/MM/DD HH:mm:ss')]
      }
      if (data.targetPopulation) {
        this.formData.targetPopulation = data.targetPopulation
      }
      if (data.id) {
        this.id = data.id
      }
      if (data.uid) {
        this.uid = data.uid
      }
      // if (this.id) {

      // }
      const labelList = []
      data.customerTagGroupDtoList.forEach(item => {
        item.customerTagDTOList.forEach(_item => {
          if (_item.choosed) {
            labelList.push(_item.customertagUid)
            this.labelListNames.push(_item.customertagName)
          }
        })
      })
      const customerDataConditionSmallDtoListChoosed = data.customerDataConditionSmallDtoList.filter(item => item.choosed)
      this.customerDataConditionUidListListNames = customerDataConditionSmallDtoListChoosed.map(item => item.customerDataConditionName)
      this.customerDataConditionSmallDtoList = data.customerDataConditionSmallDtoList
      this.formData.labelList = labelList
      this.formData.customerDataConditionUidList = customerDataConditionSmallDtoListChoosed.map(item => item.customerDataConditionUid)
      const platformList = []
      _.forEach(data.locationGroupDtoList, item => {
        if (item.choosed) {
          platformList.push(item.locationGroupUid)
        }
      })
      this.templateData.locationGroupDtoList.forEach(l => {
        var res = platformList.findIndex(item => item === l.locationGroupUid)
        if (res !== -1) {
          this.chooseList.push(l.locationGroupName)
        }
      })
      this.platformList = platformList
      this.loading = false
    },
    deleteDraf (data) {
      this.$confirm('删除后无法复原', `确认删除${data.name}？`, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await deleteTemplate({ templateUid: data.uid })
        this.$message({
          type: 'success',
          message: '删除成功!'
        })
        const _data = await getDetailTemplate({ templateUid: this.id })
        this.templateData = _data
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    async editDraf (uid) {
      this.$confirm('选择草稿后当前内容会被替换为草稿内容', '是否编辑草稿？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        Object.assign(this.$data, {
          id: this.$route && (this.$route.params.id === 'null') ? null : this.$route.params.id,
          uid: '',
          formData: {
            name: '',
            time: '',
            targetPopulation: 0,
            fileList: [],
            labelList: []
          },
          userAccount: '',
          excelFile: [],
          platformList: [],
          saveAsTemplate: false,
          templateName: '',
          labelLogic: 0,
          nameListInfo: {
            pageNum: 0,
            pageSize: 10,
            pages: 1,
            nextPage: 1,
            list: []
          },
          showNameVisible: false,
          templateData: {}
        })
        this.loadDetailTemplate(uid)
      })
    },
    beforeUpload (file) {
      const fileDir = file.name
      const suffix = fileDir.substr(fileDir.lastIndexOf('.'))
      if (fileDir === '') {
        this.$notify.error({
          title: '错误',
          message: '请导入excel文件'
        })
        return false
      }
      if (suffix !== '.xls' && suffix !== '.xlsx') {
        this.$notify.error({
          title: '错误',
          message: '请导入excel文件'
        })
        return false
      }
    },
    uploadExcel () {
      console.log('uploadExcelFn')
      if (this.excelFile.length > 0) {
        this.$confirm('已上传excel，重新上传会覆盖原文件', '确认重新上传？', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.uploadFn()
        }).catch()
      } else {
        this.uploadFn()
      }
    },
    async uploadFn () {
      const fileElem = document.getElementById('excelUpload')

      fileElem.click()
    },
    canSubmit () {
      const flag = { submit: true }
      if (!this.formData.name) {
        this.$notify.error({
          title: '错误',
          message: '方案名称不能为空'
        })
        return false
      }
      if (!this.formData.time) {
        this.$notify.error({
          title: '错误',
          message: '投放时间不能为空'
        })
        return false
      }
      if (JSON.stringify(this.getLocationGroupVoList(flag)) === '[]') {
        this.$notify.error({
          title: '错误',
          message: '必须选择至少一个投放平台'
        })
        return false
      }
      return flag.submit
    },
    async getCheckResult (type) {
      if (type === 1) {
        const res = await saveTemplate(this.formCheckData)
        this.saveTemplateId = res
        this.submitAnti = false
        if (_.isObject(res)) {
          _.map(res, (value, key) => {
            setTimeout(() => {
              this.$notify.error({
                title: '错误',
                message: value
              })
            }, 100)
          })
        } else {
          this.$message({
            type: 'success',
            message: '发布成功'
          })
          // this.$router.push('/drop-data')
          this.loading = true
          const _res = await getDetailTemplate({ templateUid: this.id })
          this.templateData.draftBox = _res.draftBox
          this.loading = false
          const index = this.$router.getRoutes().findIndex(item => item.name !== 'project-edit')
          if (index !== -1) {
            this.$router.go(-(index + 1))
          } else {
            this.$router.push('/drop-data')
          }
        }
      } else if (type === 0) {
        this.checkRepeat = false
        this.submitAnti = false
      }
    },
    async submit (type) {
      if (this.submitAnti) {
        return
      }
      this.submitAnti = true
      console.log('this.formData', this.formData)
      if (!this.canSubmit()) {
        this.submitAnti = false
        return
      }
      const locationGroupVoList = this.getLocationGroupVoList()
      if (!locationGroupVoList) {
        this.submitAnti = false
        return
      }
      const submitData = {
        name: this.formData.name,
        targetPopulation: this.formData.targetPopulation,
        startTime: dayjs(this.formData.time[0]).format('YYYY/MM/DD HH:mm:ss'),
        endTime: dayjs(this.formData.time[1]).format('YYYY/MM/DD HH:mm:ss'),
        locationGroupVoList: JSON.stringify(locationGroupVoList),
        templateName: this.templateName,
        customerDataConditionUidList: this.formData.customerDataConditionUidList,
        saveAsTemplate: this.saveAsTemplate ? 1 : 0
      }
      if (type === 0 || type === 1) {
        submitData.type = type
      }
      if (type === 2) {
        submitData.type = this.templateData.type
        submitData.save = 1
      }
      if (this.id) {
        submitData.id = this.id
      }
      if (this.uid) {
        submitData.uid = this.uid
      }
      console.log(this.saveTemplateId)

      if (this.saveTemplateId) {
        submitData.uid = this.saveTemplateId
      }
      console.log('this.$route.params.id', this.$route.params.id)
      if (submitData.targetPopulation === 0) {
        submitData.customerTagGroupVoList = JSON.stringify(this.getCustomerTagGroupVoList())
        submitData.labelLogic = this.labelLogic
      }
      if (submitData.targetPopulation * 1 === 1) {
        submitData.leadingInTemporaryTableUid = this.userAccount
      }
      const formData = new FormData()
      this.formCheckData = new FormData()
      _.map(submitData, (value, key) => {
        formData.append(key, value)
      })
      _.map(submitData, (value, key) => {
        this.formCheckData.append(key, value)
      })
      if (type === 1 || type === 0) {
        try {
          const result = await getCoveredCustomerDto(formData)

          console.log('result', result, 'aaaa')
          if (result && result.leadingInTemporaryTableUid) {
            this.$notify.error({
              title: '错误',
              message: '导入数据不允许为空'
            })
            this.submitAnti = false
            return
          }
          if (result && result.coveredCustomerDtoList && result.coveredCustomerDtoList.length > 0) {
            try {
              console.log(formData, formData.name)
              this.checkRepeat = true
              this.repeatData = result.coveredCustomerDtoList
            } catch (error) {
              this.submitAnti = false
              return false
            }
          } else {
            const res = await saveTemplate(formData)
            this.submitAnti = false
            if (_.isObject(res)) {
              _.map(res, (value, key) => {
                setTimeout(() => {
                  this.$notify.error({
                    title: '错误',
                    message: value
                  })
                }, 100)
              })
            } else {
              this.saveTemplateId = res
              this.$message({
                type: 'success',
                message: '发布成功'
              })
              this.needDeleteLocationGroupUids.forEach(item => {
                if (this.platformList.indexOf(item) === -1) {
                  deleteTargetLocationMappingByTemplateUidAndLocationGroupUid({ locationGroupUid: item, templateUid: this.uid })
                }
              })
              this.needDeleteTargetLocations.forEach(item => {
                deleteTargetLocationMapping(item.targetLocationMappingUid)
              })
              // this.$router.push('/drop-data')
              this.loading = true
              const _res = await getDetailTemplate({ templateUid: this.id })
              this.templateData.draftBox = _res.draftBox
              this.loading = false
              const index = this.$router.getRoutes().findIndex(item => item.name !== 'project-edit')
              if (index !== -1) {
                this.$router.go(-(index + 1))
              } else {
                this.$router.push('/drop-data')
              }
            }
          }
        } catch (e) {
          this.submitAnti = false
        }

        // this.loadDetailTemplate(this.id)
      } else {
        const result = await getCoveredCustomerDto(formData)
        if (result.coveredCustomerDtoList && result.coveredCustomerDtoList.length > 0) {
          try {
            this.checkRepeat = true
          } catch (error) {
            this.submitAnti = false
            return
          }
        }
        if (result.coveredCustomerDtoList && result.coveredCustomerDtoList.length > 0) {
          this.$confirm('发布后，会根据投放开始时间生效，确认发布此条方案吗？', '确认发布方案？', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(async () => {
            const res = await saveTemplate(formData)
            this.saveTemplateId = res
            this.submitAnti = false
            if (_.isObject(res)) {
              _.map(res, (value, key) => {
                setTimeout(() => {
                  this.$notify.error({
                    title: '错误',
                    message: value
                  })
                }, 100)
              })
            } else {
              this.$message({
                type: 'success',
                message: '保存成功'
              })
              const index = this.$router.getRoutes().findIndex(item => item.name !== 'project-edit')
              if (index !== -1) {
                this.$router.go(-(index + 1))
              } else {
                this.$router.push('/drop-data')
              }
            }
          })
        } else {
          const res = await saveTemplate(formData)
          this.saveTemplateId = res
          this.submitAnti = false
          if (_.isObject(res)) {
            _.map(res, (value, key) => {
              setTimeout(() => {
                // const nameList = {
                //   imgSkipUrl: '跳转链接',
                //   popRate: '弹窗频率'
                // }

                if (key.split('_').length > 1) {
                  const locationUid = key.split('_')[0]
                  // const name = nameList[key.split('_')[1]]
                  const loactionGroupName = locationGroupList.find(item => item.locationUid === locationUid)

                  this.$notify.error({
                    title: `${loactionGroupName.locationName}`,
                    message: `${value}`
                  })
                } else {
                  this.$notify.error({
                    title: '错误',
                    message: value
                  })
                }
              }, 100)
            })
          } else {
            this.$message({
              type: 'success',
              message: '保存成功'
            })
            const index = this.$router.getRoutes().findIndex(item => item.name !== 'project-edit')
            if (index !== -1) {
              this.$router.go(-(index + 1))
            } else {
              this.$router.push('/drop-data')
            }
          }
        }
      }
    },
    getLocationGroupVoList (flag) {
      console.log('this', this)
      const locationGroupVoList = []
      // let weightFlag = true
      let imgFlag = true
      let backFalse = true
      const that = this

      _.forEach(this.selectPlatformInfoList, (item, index) => {
        const platformData = that.$refs[item.locationGroupUid].platformData || that.$refs[item.locationGroupUid][0].platformData
        if (!backFalse) {
          return false
        }
        console.log('item', item)
        console.log('platformData', platformData)
        // let weightLength = 0
        // item.locationDtoList.forEach(e => {
        //   if (e.weightShow) {
        //     weightLength += 1
        //   }
        // })
        const locationVoList = []
        _.forEach(item.locationDtoList, (locationInfo, i) => {
          backFalse = true
          console.log('platformData.location', platformData.location)
          const locationGroupUid = platformData.location.find(id => id === locationInfo.locationUid)
          const _data = {
            locationUid: locationGroupUid
          }
          if (locationGroupUid === '1005') {
            _data.topTrabeculaContent = locationInfo.topTrabeculaContent
            _data.topTrabeculaSkipUrl = locationInfo.topTrabeculaSkipUrl
          } else if (locationGroupUid === '1006') {
            _data.bottomRightWindowTitle = locationInfo.bottomRightWindowTitle
            _data.bottomRightWindowContent = locationInfo.bottomRightWindowContent
            _data.bottomRightWindowButton = locationInfo.bottomRightWindowButton
            _data.bottomRightWindowSkipUrl = locationInfo.bottomRightWindowSkipUrl
          } else if (locationGroupUid === '1007') {
            _data.generalViewBottomRadio = locationInfo.generalViewBottomRadio
            _data.generalViewContent = locationInfo.generalViewContent
            _data.generalViewQrCodeUrl = locationInfo.generalViewQrCodeUrl
            _data.generalViewSkipUrl = locationInfo.generalViewSkipUrl
            _data.generalViewTel = locationInfo.generalViewTel
          } else if (locationGroupUid === '10003') {
            _data.aiSettingVideoLink = locationInfo.aiSettingVideoLink
          } else if (locationGroupUid === '1008') {
            _data.centerHtmlType = locationInfo.centerHtmlType
            _data.imgSkipUrl = locationInfo.imgSkipUrl
          }
          if (platformData.weightList && platformData.weightList[i]) {
            _data.weight = platformData.weightList[i]
          }
          if (locationInfo.choosed && this.needDeleteTargetLocations.findIndex(item => item.locationUid === locationInfo.locationUid) === -1 && ((locationInfo.bgFillingShow && locationInfo.bgFilling === 0 && locationInfo.rgb === '') || (locationInfo.bgFillingShow && locationInfo.bgFilling === 1 && (locationInfo.rgb === '' || locationInfo.rgb2 === '')))) {
            backFalse = false
          } else if (locationGroupUid !== '1005' && locationGroupUid !== '1006') {
            _data.bgFilling = locationInfo.bgFilling
            _data.rgb = locationInfo.rgb
            _data.rgb2 = locationInfo.rgb2
          }
          if (locationGroupUid === '3007') {
            _data.mobileOfficialWebsiteVoList = locationInfo.mobileOfficialWebsiteVoList
          }
          if (!_.isUndefined(platformData.dialogFrequency[i])) {
            _data.popRate = platformData.dialogFrequency[i]
          }
          if (platformData.imageList.length < platformData.location.filter(item => item !== '1005' && item !== '1006' && item !== '1007' && item !== '3007' && item !== '10003' && item !== '1008').length && imgFlag) {
            console.log('imgFlag1', imgFlag)
            imgFlag = false
            this.$notify.error({
              title: '错误',
              message: '广告图未上传'
            })
            if (flag) {
              flag.submit = false
            }
          } else {
            _.forEach(platformData.imageList, item => {
              console.log('item', item)
              if (!item && imgFlag) {
                imgFlag = false
                this.$notify.error({
                  title: '错误',
                  message: '广告图未上传2'
                })
                if (flag) {
                  flag.submit = false
                }
              }
              if (item.index === i) {
                if (!item.url && imgFlag) {
                  console.log('imgFlag2', imgFlag)
                  imgFlag = false
                  this.$notify.error({
                    title: '错误',
                    message: '广告图未上传3'
                  })
                  if (flag) {
                    flag.submit = false
                  }
                }
                _data.imgUrl = item.url.split('//')[1]
              }
            })
          }
          // _.forEach(platformData.linkList, item => {
          //   if (item.index === i) {
          //     _data.imgSkipUrl = item.url
          //   }
          // })
          if (platformData.linkList[i] && platformData.linkList[i].switch && locationGroupUid !== '1008') {
            _data.imgSkipUrl = platformData.linkList[i].url
          }
          if (_data.centerHtmlType === 1 && locationGroupUid === '1008') {
            _data.imgUrl = ''
          }
          console.log('_data', _data)
          if (_data.locationUid) {
            locationVoList.push(_data)
          }
          if (!backFalse) {
            return false
          }
        })
        const data = {
          locationGroupUid: item.locationGroupUid,
          locationVoList: _.compact(locationVoList)
        }

        locationGroupVoList.push(data)
      })
      if (!backFalse) {
        this.$notify.error({
          title: '错误',
          message: '填充背景未选择或填写'
        })
        return false
      }
      return locationGroupVoList
    },
    getCustomerTagGroupVoList () {
      const customerTagGroupVoList = []
      _.forEach(this.templateData.customerTagGroupDtoList, (item) => {
        _.forEach(item.customerTagDTOList, (_item) => {
          _.forEach(this.formData.labelList, (id) => {
            if (id === _item.customertagUid) {
              const i = customerTagGroupVoList.findIndex(e => e.customertaggroupUid === item.customertaggroupUid)
              if (i === -1) {
                customerTagGroupVoList.push({
                  customertaggroupUid: item.customertaggroupUid,
                  customerTagVoList: [{
                    customertagUid: _item.customertagUid
                  }]
                })
              } else {
                customerTagGroupVoList[i].customerTagVoList.push({
                  customertagUid: _item.customertagUid
                })
              }
            }
          })
        })
      })
      return customerTagGroupVoList
    },
    async changeNameListTabelPage (pageNum) {
      if (this.formData.targetPopulation === 1) {
        const uid = this.userAccount || this.templateData.uid
        const data = await getCustomerInfoByLeadingIn({ pageNum, pageSize: this.nameListInfo.pageSize, isNew: this.isNew, uid })
        this.nameListInfo = data
      } else {
        const data = await getCustomerTagMapping({ labelLogic: this.labelLogic, pageNum, pageSize: this.nameListInfo.pageSize, customerTagUids: _.join(this.formData.labelList, ',') })
        this.nameListInfo = data
      }
    },
    async showNameList () {
      console.log('this.formData.targetPopulation', this.formData.targetPopulation)
      console.log('this.labelLogic', this.labelLogic)
      this.showNameVisible = true
      if (this.formData.targetPopulation === 1) {
        const uid = this.userAccount || this.templateData.uid
        if (uid) {
          const data = await getCustomerInfoByLeadingIn({ pageNum: 1, pageSize: this.nameListInfo.pageSize, isNew: this.isNew, uid })
          this.showNameLoading = false
          this.nameListInfo = data
        } else {
          this.$notify.error({
            title: '错误',
            message: '请先上传excel再查看名单'
          })
          this.showNameVisible = false
        }
      } else {
        const data = await getCustomerTagMapping({ labelLogic: this.labelLogic, pageNum: 1, pageSize: this.nameListInfo.pageSize, customerTagUids: _.join(this.formData.labelList, ',') })
        this.showNameLoading = false
        this.nameListInfo = data
      }
    },
    deletePlatform (id) {
      const index = this.selectPlatformInfoList.findIndex(item => item.locationGroupUid === id)
      if (index !== -1) {
        var deleteLocation = this.selectPlatformInfoList[index]
        deleteLocation.locationDtoList.map(item => {
          item.imgUrl = ''
        })
        this.selectPlatformInfoList.splice(index, 1, deleteLocation)
      }
      this.needDeleteLocationGroupUids.push(id)
      this.platformList = _.pull(this.platformList, id)
    },
    isDisabled (id) {
      return this.platformOptions.findIndex(item => item.id === id) !== -1
    },
    handleRemove (file, fileList) {
      this.excelFile = []
    },
    backPage () {
      this.$router.go(-1)
    }
  }
}
</script>
<style lang="less">
.show_name {
  .el-dialog__header {
    padding-bottom: 15px;
    border-bottom: 1px solid var(--form-line);
  }
}
.el-message-box__btns {
  display: flex;
  justify-content: flex-end;
}
.el-radio-button__inner,
.el-checkbox-button__inner {
  font-weight: 300;
}
.el-radio-button__orig-radio:checked + .el-radio-button__inner,
.el-radio__input.is-checked .el-radio__inner,
.el-checkbox-button.is-checked .el-checkbox-button__inner,
.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background: #2878ff;
}
.el-checkbox-button.is-checked .el-checkbox-button__inner {
  border: none !important;
}
.el-button--small {
  font-size: 14px;
}
.headline > .el-button {
  height: 40px !important;
}
.el-radio__input.is-checked + .el-radio__label {
  color: #2878ff;
}
.chooseTagName {
  margin-top: 4px;
  padding: 0 8px;
  height: 32px;
  display: inline-block;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #404757c7;
  background: #dde4f04d;
  border-radius: 4px;
  line-height: 32px;
  margin-right: 4px;
}
.chooseTagName:last-of-type {
  margin-right: 10px;
}
.el-button {
  height: 32px !important;
  font-weight: 200;
  align-items: center;
  justify-content: center;
}
.el-input {
  height: 32px;
}
.el-form-item {
  margin-bottom: 10px;
  align-items: center;
}
.el-checkbox-button__inner {
  border: 1px solid #dcdfe6 !important;
  border-radius: 4px !important;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.targetPopulation i {
  font-size: 28px;
}
.targetPopulation .el-radio-button__inner > div {
  display: flex;
  align-items: center;
}
.el-range-separator {
  height: auto !important;
}
.select-trigger {
  width: 230px;
}
.el-input__inner {
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.el-radio-button__inner {
  height: 32px;
  display: flex;
  align-items: center;
}
</style>
<style lang="less" scoped>
.dialog-footer,
.footer > div {
  display: flex;
  justify-content: flex-end;
}
.pagination {
  width: 100%;
  margin-top: 20px;
}
.el-form-item__content p {
  margin: 0;
}
.panel {
  .back {
    font-size: 16px;
    color: var(--main-text);
    display: flex;
    align-items: center;
    cursor: pointer;
    margin-bottom: 18px;
    height: 28px;
    border-right: 1px solid var(--form-line);
    width: 90px;
    i {
      font-size: 28px;
    }
  }
}
.panel:last-child {
  margin-bottom: 90px;
}
.footer {
  position: fixed;
  bottom: 0px;
  left: 96px;
  background-color: var(--white);
  border-radius: 1px;
  padding: 23px 53px;
  width: calc(100% - 200px);
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 12px;
  z-index: 100;
  box-shadow: 0 -2px 8px 0 #eeeeee;
  &__button {
    width: 96px;
    height: 36px;
  }
  .set_template {
    display: flex;
    justify-content: center;
    align-items: center;
    &__checkbox {
      margin-right: 10px;
    }
    &__input {
      width: 280px;
    }
  }
}

.edit-panel {
  background-color: var(--white);
  border-radius: 1px;
  padding: 20px 30px;
  .el-checkbox-button {
    margin-right: 8px;
  }
  .title {
    font-size: 20px;
    color: var(--main-text);
    margin-bottom: 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .el-checkbox {
      margin-right: 10px;
    }
  }
}
.show_list {
  padding: 0 20px;
  margin-left: 5px;
}
.tag_edit .el-form-item__content > div {
  display: flex;
  align-items: center;
}
.draft-box {
  padding: 10px 13px;
  &__cell {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    cursor: pointer;
    span {
      font-size: 16px;
      color: var(--main-text);
    }
    i {
      font-size: 16px;
      color: #91959f;
    }
  }
}
.excel {
  display: flex;
  align-items: center;
  height: 100%;
}
</style>
